import { ApplicationVm } from "../../applications/applicationVm"
import { nutrients } from "../../nutrients"
import { defineDirective } from "../../omnia"
import { getProductUnitsText, getRoundedValueForUnit } from "../../services/units"
import { FertiliserAppUnit, NutrientType } from "../../types"

export class PlanApplicationsTableCtrl {

    static create(): ng.IDirective {

        return defineDirective(PlanApplicationsTableCtrl, "app/nutrition/dashboard/applications/apps.html", {
            applications: "<",
            selectable: "<",
            selectedId: "<",
            onSelect: "&"
        })

    }

    static $inject = []

    public applications: ApplicationVm[]
    public selectable = false
    public selectedId = 0

    public onSelect: () => (application: ApplicationVm) => void

    public getNutrientName(nutrient: NutrientType) {
        if (!nutrient) return null
        return nutrients.find(n => n.value === nutrient).text
    }

    public getProductUnitsText(product: ApplicationVm, unit: FertiliserAppUnit) {
        return getProductUnitsText(product, unit)
    }

    public select(app: ApplicationVm) {
        if (this.selectable && this.onSelect) {
            this.onSelect()(app)
        }
    }

}
